import { IAssetCategory } from '../constants/assets';
import { StagesData } from '../types';
import { CategoryFilter, FilterItem, StageFilter } from '../types/filter';
import { getAvailableStages } from './envs';

export const getAccessibleStages = (stagesData: StagesData[]): string[] =>
  stagesData?.reduce((stages: string[], { title, items }) => (items.length ? [...stages, title] : stages), []);

export const computeStageFilterItems = (accessibleStages: string[] = []): FilterItem[] => {
  const availableStages = getAvailableStages();

  return Object.values(StageFilter)
    .filter(
      (filterName: StageFilter) => availableStages.includes(filterName.toLowerCase()) || filterName === StageFilter.all
    )
    .map((filterName: StageFilter) => {
      return {
        name: filterName,
        isDisabled: filterName === StageFilter.all ? false : !accessibleStages.includes(filterName),
      };
    });
};

export const computeSubcategoriesFilterItems = (subcategories: IAssetCategory[] = []): FilterItem[] => {
  const scopesKeys = subcategories?.map(subcategory => subcategory.name) || [];
  const shortKeys = [StageFilter.all as string].concat(scopesKeys).map(item => {
    return item.replace(/ .*/, '') as CategoryFilter;
  });

  return shortKeys.map(
    (filterName: CategoryFilter): FilterItem => ({
      name: filterName,
      isDisabled: false,
    })
  );
};
